import request from '@/utils/request'


// 获取购买证核查列表
export function getGmzHcList(data) {
    return request({
      method: "post",
      url: "/yzdservice/api/hc/gmzhc/list",
      data: data
    })
}

// 设置购买证核查
export function gmzHcUpdate(data) {
    return request({
        method: 'post',
        url: '/yzdservice/api/hc/gmzhc/update',
        data: data
    })
}

// 查询单位
export function getDwhc(data) {
  return request({
    method: 'post',
    url: '/yzdservice/api/hc/dwhc/info',
    data: data
  })
}
// 加入往来单位
export function wldwAdd(data) {
  return request({
    method: 'post',
    url: '/yzdservice/enterprise/wldw/addOrUpdSave',
    data: data
  })
}
